const e = "TokenService";
export {
  e as TOKEN_SERVICE
};
